module.exports = __webpack_public_path__ + "static/media/ic_plus.ee5bfa9a.svg";